import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=596f9672&scoped=true&"
import script from "./noPermission.vue?vue&type=script&lang=js&"
export * from "./noPermission.vue?vue&type=script&lang=js&"
import style0 from "./noPermission.vue?vue&type=style&index=0&id=596f9672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f9672",
  null
  
)

component.options.__file = "noPermission.vue"
export default component.exports